import { useState } from 'react'
import { api } from '../lib/api'
import { useTrail } from '../lib/queries'
import { Empty, PageHead, Skel } from '../components/ui'
import { thaiDateTime } from '../lib/format'

export function AuditTrail() {
  const q = useTrail()
  const [check, setCheck] = useState<{ valid: boolean; first_broken_id: number } | null>(null)
  const [busy, setBusy] = useState(false)

  async function verify() {
    setBusy(true)
    try { setCheck(await api('/v1/audit-trail/verify')) } finally { setBusy(false) }
  }

  const rows = q.data ?? []
  return (
    <>
      <PageHead title="ร่องรอยการตรวจสอบ" sub="บันทึกแบบ append-only พร้อม hash chain ตรวจสอบได้ทุกเมื่อ"
        actions={<button className="btn" onClick={() => void verify()} disabled={busy}>{busy ? 'กำลังตรวจ…' : 'ตรวจสอบความสมบูรณ์'}</button>} />
      {check ? (
        <div className="card card-pad" style={{ marginBottom: 16, borderColor: check.valid ? 'rgba(46,125,100,0.4)' : 'rgba(166,58,74,0.45)' }}>
          <div className="row">
            <span style={{ color: check.valid ? 'var(--color-emerald-soft)' : '#E3A0A9', fontSize: 13 }}>
              {check.valid ? 'ห่วงโซ่สมบูรณ์ — ไม่พบการแก้ไขย้อนหลัง' : `พบจุดที่ขาดหายที่ event #${check.first_broken_id}`}
            </span>
          </div>
        </div>
      ) : null}
      {q.isLoading ? <div className="stack"><Skel h={44} /><Skel h={44} /><Skel h={44} /></div>
        : rows.length === 0 ? <div className="card"><Empty title="ยังไม่มีเหตุการณ์" body="ทุกการกระทำในระบบจะถูกบันทึกที่นี่" /></div>
        : (
          <div className="table-wrap">
            <table className="data">
              <thead><tr><th>เวลา</th><th>ผู้กระทำ</th><th>การกระทำ</th><th>ทรัพยากร</th><th>แฮช</th></tr></thead>
              <tbody>
                {rows.map((e) => (
                  <tr key={e.id} style={{ cursor: 'default' }}>
                    <td className="dim">{thaiDateTime(e.occurred_at)}</td>
                    <td>{e.actor_type}</td>
                    <td><span className="mono" style={{ color: 'var(--color-gold)' }}>{e.action}</span></td>
                    <td className="dim">{e.resource_type}{e.resource_id ? ` · ${e.resource_id.slice(0, 8)}` : ''}</td>
                    <td className="mono dim" style={{ fontSize: 10.5 }}>{e.record_hash.slice(0, 16)}…</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </>
  )
}
